"use client";

import { motion } from "framer-motion";
import type { ReactNode } from "react";

type PageEntranceProps = {
	children: ReactNode;
	className?: string;
	delay?: number;
	duration?: number;
	y?: number;
};

export default function PageEntrance({
	children,
	className,
	delay = 0.34,
	duration = 0.9,
	y = 28,
}: PageEntranceProps) {
	return (
		<motion.div
			className={className}
			initial={{ opacity: 0, y, scale: 0.985, filter: "blur(8px)" }}
			animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
			transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
		>
			{children}
		</motion.div>
	);
}
